import { render, staticRenderFns } from "./contractDialog.vue?vue&type=template&id=38c605eb&scoped=true&"
import script from "./contractDialog.vue?vue&type=script&lang=js&"
export * from "./contractDialog.vue?vue&type=script&lang=js&"
import style0 from "./contractDialog.vue?vue&type=style&index=0&id=38c605eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c605eb",
  null
  
)

export default component.exports